export default "__VITE_ASSET__BD8cvgUI__"